export default __webpack_public_path__ + "static/media/groundnut.b4e7a29c.png";